<style lang="less">
 @import './login.less';
</style>
<template>
   <div class="m_login_content">
    <div class="m_login_main">
      <div class="m_login_main_top">
      	<p>{{$t('login.title')}}</p>
      	<!--<p  @click="changeShow(3)" >{{$t('login.scanLoginTitle')}}</p>-->
      </div>
      <div class="m_login_bottom clearfix">
        <div class="m_login_main_bottom_left">
          <h1></h1>
        </div>
        <div class="m_login_main_bottom_right">
          <div class="m_login_form">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules" @keyup.enter.native="loginIn()"  v-if="isShow!=3">
            	<el-form-item style="line-height: 10px;">
	              <el-radio-group v-model="form.type">
				    <el-radio label="Operator">运营商</el-radio>
				    <el-radio label="Customer">门店客户</el-radio>
				  </el-radio-group>
            	</el-form-item>
            	<div v-if="isShow ==1">
	              <el-form-item :label="$t('login.account')" prop="username">
	                <el-input v-model="form.username" :placeholder="$t('login.accountMsg')"></el-input>
	              </el-form-item>
	              <el-form-item :label="$t('login.password')" prop="password">
	              	<div style="display: flex;justify-content: space-between;">
		                <el-input v-model="form.password" type="password" :placeholder="$t('login.passMsg')"></el-input>
		             </div>
	              </el-form-item>
            	</div>
            	<div v-if="isShow==2">
	              <el-form-item :label="$t('login.account')" prop="username">
	                <el-input v-model="form.username" :placeholder="$t('login.phoneMsg')"></el-input>
	              </el-form-item>
	              <el-form-item :label="$t('login.verification')" prop="vc_code">
	              	<div style="display: flex;justify-content: space-between;">
		                <el-input v-model="form.vc_code" :placeholder="$t('login.phoneCodeMsg')" style="width: 70%;"></el-input>
		                <el-button type="text" style="font-size: 12px;" @click="getCode">{{$t('login.Verification')}}</el-button>
	              	</div>
	              </el-form-item>
            	</div>
            	
              <el-form-item>
                <el-button
                	style="width:100%"
                  type="primary"
                  @click="loginIn"
                  size="mini"
                  >{{$t('login.LoginText')}}</el-button>
                </el-form-item>
                
            </el-form>
        	<div id="code" v-if="isShow==3" style="text-align: center;margin-bottom: 30px;">
        	</div>
              <div style="text-align: center;margin-top: -30px;font-size: 26px;font-weight: 700;">
              	   <!--<el-button type="text" @click="changeShow(2)" v-if="isShow == 1">{{$t('login.phoneLoginTitle')}}</el-button>-->
                   <el-button type="text" @click="changeShow(1)"  v-if="isShow == 2 || isShow == 3">{{$t('login.accoutLoginTitle')}}</el-button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from '@/utils/qrcode'
import regulars from "@/utils/regular";
import storage from '@/utils/storage'
export default {
   data() {
    return {
	      form: {
	        username: null,
	        password: null,
//	        vc_code:null,
	        type:'Operator'
	      },
	      isShow:1,
	      rules: {
	      	username: [
	            { required: true, 
	            	message:this.$t('login.accountMsg2'), 
	            	trigger: 'blur' 
	            },
//	            {
//					pattern:regulars.phoneNumber,
//					message: "手机号码格式错误"
//				}
	            
	        ],
	        password:[
	          { required: true, 
	          	message: this.$t('login.passMsg'), 
	          	rigger: 'blur' 
	          }
	        ],
	        vc_code:[
	          { required: true, 
	          	message: this.$t('login.phoneCodeMsg'), 
	          	trigger: 'blur' 
	          }
	        ]
	      },
	      token:null,
	      timerIndex:null,
	      loginToken: storage.get('token')
	    };
	  },
	  computed: {
		userInfo() {
	        return this.$store.state.member.userInfo;
	 	}
	},
	created(){
		this.isShow=1;
		if(this.userInfo != null && this.loginToken !=null){
			console.log('1212')
			this.$router.push('main');
		}else{
			localStorage.removeItem('token');
			localStorage.removeItem('userInfo');
			localStorage.removeItem('skuType');
		}
	},
	methods:{
		initForm() {
			if(this.$refs.form) {
				this.$refs.form.resetFields();
			}
			this.form={
				username:null,
				password:null,
//				vc_code:null,
				type:'Operator'
			}
		},
		changeShow(val){
			this.isShow = val;
			this.initForm();
			if(val==3){
				setTimeout(()=>{
					$('#code').html("")
					this.getScode();
				},300)
			}
			clearInterval(this.timerIndex);
		},
		getScode(){
			this.$http.log.getScode().then((res) => {
				if(res.return_code==0) {
					console.log(res.data)
					qrcode("#code").qrcode({
						render: "canvas",
						width: 150, //宽度
						height: 150, //高度
						correctLevel: 0,
						text: res.data.qrcode//任意内容
					});
					this.token = res.data.login_token;
					this.timerIndex = setInterval(()=>{
						this.checkCode()
					},2000)
					
				} else {
					this.$message.error({
						message:this.$t(res.return_key),
					});
				}
			}, (err) => {
				this.$message.error({
					message:err,
				});
			});
		},
		checkCode(){
			 this.$http.log.checkScode({
			 	login_token:this.token
			 }).then((res) => {
				if(res.return_code==0) {
					console.log(res.data)
					if(res.data.login){
						clearInterval(this.timerIndex);
						this.$message.success({
							message: this.$t(res.return_key),
							onClose:()=>{
								this.$store.commit('setToken', res.data.userInfo.token);
						      	this.$store.commit('setUserInfo', res.data.userInfo);
						      	this.$store.commit('setSkuType', this.form.type);
								this.$router.push("/main");
							}
						});
					}
				} else {
					this.$message.error({
						message:this.$t(res.return_key),
					});
				}
			}, (err) => {
				this.$message.error({
					message:err,
				});
			});
		},
		getCode(){
			if (this.isShow == 2 && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.username))) {
                this.$message.error({
					message:this.$t('login.phoneMsg2'),
				});
                return;
            }
			 this.$http.log.getCode({
			 	login_mobile:this.form.username
			 }).then((res) => {
				if(res.return_code==0) {
					this.$message.error({
						message:this.$t(res.return_key),
					});
				} else {
					this.$message.error({
						message:this.$t(res.return_key),
					});
				}
			}, (err) => {
				this.$message.error({
					message:err,
				});
			});
		},
	  	loginIn(){
			this.$refs.form.validate((valid) => {
			        if (valid) {
			        	this.login();
			        } else {
			          return false;
			        }
			      });
			},
	    login() {
	    	 this.$http.log.login(this.form).then((res) => {
				if(res.return_code==0) {
					this.$message.success({
						message: this.$t(res.return_key),
						onClose:()=>{
							this.$store.commit('setToken', res.data.access_token);
					      	this.$store.commit('setUserInfo', res.data.userInfo);
						    this.$store.commit('setSkuType', this.form.type);
							this.$router.push("/main");
							
						}
					});
				} else {
					this.$message.error({
						message:this.$t(res.return_key),
					});
				}
			}, (err) => {
				this.$message.error({
					message:err,
				});
			});
	      
	      
		},
  	}
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/views/Login/index.vue